/* Lunaire: one-click "Subscribe & save X%" upgrade for cart line items.
   Works in both the cart drawer and the /cart page.
   - Single-line buttons are rendered by snippets/cart-subscribe-upgrade.liquid
     on one-time lines whose variant has a subscription selling plan.
   - Bundle buttons (.lunaire-sub-upgrade--bundle, rendered by
     snippets/cart-bundle-card.liquid) convert ALL component lines.

   2026-07-24 rework (after a live half-converted cart, Clarity user 11634r0):
   the old flow posted /cart/change.js once per line (8 sequential network
   calls for the 4-SKU ritual). A shopper navigating away mid-chain stranded
   the cart half-subscribed: the bundle card ungroups, the leftover one-time
   line loses the automatic Bundle & Save discount, and the display reads as
   "3 rituals at 50% off". The new flow is an atomic pair:
     1. ONE /cart/add.js POST adds every component on the selling plan.
     2. ONE /cart/update.js POST zeroes the old one-time lines by key.
   Each request is all-or-nothing server-side. A sessionStorage journal marks
   the gap between them; if the shopper navigates away mid-pair, the journal
   resumes and finishes on the next page load. A separate healer finishes
   carts left half-converted by the OLD code. */
(function () {
  /* This asset is included by BOTH snippets/cart-drawer.liquid (site-wide)
     and sections/main-cart-items.liquid, so on /cart the file executes twice.
     Everything below must run once: a second instance would double the click
     handling and make the healer add duplicate lines. */
  if (window.__lunaireSubUpgrade) return;
  window.__lunaireSubUpgrade = true;

  var busy = false;
  var JOURNAL_KEY = 'lunaire-sub-upgrade-journal';
  var REVERT_JOURNAL_KEY = 'lunaire-sub-revert-journal';
  var JOURNAL_MAX_AGE = 6 * 60 * 60 * 1000; /* 6h: stale journals are dropped */

  /* Bundle registry. Primary source: window.lunaireBundles, generated from
     snippets/cart-bundle-helper.liquid (mode 'json') by cart-drawer.liquid —
     future bundles added to the helper flow through automatically. The
     hardcoded list is only a fallback for pages that somehow render without
     the drawer snippet. */
  var BUNDLES = (window.lunaireBundles && window.lunaireBundles.length) ? window.lunaireBundles : [
    { handle: 'renewal-ritual', variants: ['51456410255655', '51456449347879', '51456549519655', '51475978551591'], plan: 692630946087 },
    { handle: 'calm-ritual', variants: ['51565278363943', '51462948782375', '51565278888231'], plan: 692704641319 },
    { handle: 'night-hair-ritual', variants: ['52111695642919', '52111692005671', '52111689285927'], plan: 693606154535 }
  ];

  /* Hidden line marker set by the ritual PDP buy boxes since 2026-07-24.
     Lines converted here must carry their source line's properties forward so
     the tag state stays invariant, and removals must only touch lines of the
     same tag state (a standalone untagged duplicate survives). */
  function tagOf(line) {
    return (line && line.properties && line.properties._lunaire_ritual) || '';
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('.lunaire-sub-upgrade') : null;
    if (!btn || btn.disabled || busy) return;
    event.preventDefault();

    var planId = parseInt(btn.getAttribute('data-selling-plan'), 10);
    if (!planId) return;
    var isBundle = btn.hasAttribute('data-line-keys');
    /* Cart-level offer (snippets/lunaire-sub-offer): several lines, each with
       its OWN plan, because the catalogue does not share one rate. */
    var isMulti = btn.hasAttribute('data-sub-lines');

    var oldHTML = btn.innerHTML;
    var card = btn.closest('.cart-bundle-card');
    busy = true;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = 'Updating…';
    if (card) card.classList.add('is-loading');

    var work;
    if (isMulti) {
      work = convertMulti(btn);
    } else if (isBundle) {
      work = convertBundle(btn, planId);
    } else {
      work = convertSingle(btn, planId);
    }

    work
      .then(function () {
        return refreshCartUI();
      })
      .then(function () {
        busy = false;
      })
      .catch(function (error) {
        var message = error && error.message ? error.message : 'Could not switch to a subscription. Please try again.';
        /* Refresh first so the displayed state is accurate either way. */
        refreshCartUI()
          .catch(function () {})
          .then(function () {
            busy = false;
            btn.disabled = false;
            btn.classList.remove('is-loading');
            btn.innerHTML = oldHTML;
            if (card) card.classList.remove('is-loading');
            alert(message);
          });
      });
  });

  /* ------------------------- revert to one-time -------------------------- */
  /* The mirror of the upgrade above, rendered by
     snippets/cart-onetime-revert.liquid on subscription lines. Same atomic
     pair (add the one-time line, then zero the subscription line) and the
     same journal discipline, but its own journal key: the subscribe resume
     finishes a cart TOWARD the plan, and must never pick up a revert. */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('.lunaire-sub-revert') : null;
    if (!btn || btn.disabled || busy) return;
    event.preventDefault();

    var oldHTML = btn.innerHTML;
    busy = true;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = 'Updating…';

    convertToOneTime(btn)
      .then(function () { return refreshCartUI(); })
      .then(function () { busy = false; })
      .catch(function (error) {
        var message = (error && error.message) || 'Could not switch to a one-time purchase. Please try again.';
        refreshCartUI()
          .catch(function () {})
          .then(function () {
            busy = false;
            btn.disabled = false;
            btn.classList.remove('is-loading');
            btn.innerHTML = oldHTML;
            alert(message);
          });
      });
  });

  function convertToOneTime(btn) {
    var capturedKey = btn.getAttribute('data-line-key');
    if (!capturedKey) return Promise.resolve(null);
    return getCart().then(function (cart) {
      /* Captured key first, variant-id fallback for keys gone stale (adding or
         dropping a line can re-hash keys when an automatic discount attaches). */
      var line = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === capturedKey && cart.items[i].selling_plan_allocation) { line = cart.items[i]; break; }
      }
      if (!line) {
        var variantId = String(capturedKey).split(':')[0];
        for (var j = 0; j < cart.items.length; j++) {
          var cand = cart.items[j];
          if (String(cand.variant_id) === variantId && cand.selling_plan_allocation) { line = cand; break; }
        }
      }
      if (!line) return null;

      var lineTag = tagOf(line);
      var planId = line.selling_plan_allocation.selling_plan.id;
      writeRevertJournal({ variant: String(line.variant_id), plan: planId, tag: lineTag, ts: Date.now() });

      var item = { id: line.variant_id, quantity: line.quantity };
      if (line.properties) item.properties = line.properties;
      return postJSON('/cart/add.js', { items: [item] })
        .then(function () { return removeSubLines(String(line.variant_id), planId, lineTag); })
        .then(function (result) { clearRevertJournal(); return result; });
    });
  }

  /* Zero every line of this variant that still carries the given plan and tag
     state, in ONE /cart/update.js call keyed by line key. Keyed by plan id as
     well as variant so a line on a DIFFERENT plan is never collateral. */
  function removeSubLines(variantId, planId, tag) {
    return getCart().then(function (cart) {
      var updates = {};
      var found = false;
      cart.items.forEach(function (it) {
        if (!it.selling_plan_allocation) return;
        if (String(it.variant_id) !== variantId) return;
        if (String(it.selling_plan_allocation.selling_plan.id) !== String(planId)) return;
        if (tagOf(it) !== (tag || '')) return;
        updates[it.key] = 0;
        found = true;
      });
      if (!found) return null;
      return postJSON('/cart/update.js', { updates: updates });
    });
  }

  /* Bundle path: one atomic add of every component on the plan, then one
     atomic update zeroing the old one-time lines. */
  function convertBundle(btn, planId) {
    var capturedKeys = (btn.getAttribute('data-line-keys') || '').split('|').filter(Boolean);
    return getCart().then(function (cart) {
      /* Resolve the one-time component lines to convert: captured keys first,
         variant-id fallback for keys gone stale (discount re-hash). */
      var lines = [];
      capturedKeys.forEach(function (key) {
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (it.key === key && !it.selling_plan_allocation) {
            if (lines.indexOf(it) === -1) lines.push(it);
            return;
          }
        }
      });
      /* Tag state of this conversion group: the card only consumes lines of
         one tag state, so any resolved line defines it. */
      var groupTag = lines.length ? tagOf(lines[0]) : null;
      capturedKeys.forEach(function (key) {
        var variantId = String(key).split(':')[0];
        var already = lines.some(function (l) { return String(l.variant_id) === variantId; });
        if (already) return;
        for (var j = 0; j < cart.items.length; j++) {
          var cand = cart.items[j];
          if (String(cand.variant_id) === variantId && !cand.selling_plan_allocation &&
              (groupTag === null || tagOf(cand) === groupTag) && lines.indexOf(cand) === -1) {
            if (groupTag === null) groupTag = tagOf(cand);
            lines.push(cand);
            break;
          }
        }
      });
      if (!lines.length) return null; /* nothing left to convert */
      if (groupTag === null) groupTag = tagOf(lines[0]);

      writeJournal({ variants: lines.map(function (l) { return String(l.variant_id); }), plan: planId, tag: groupTag, ts: Date.now() });

      var items = lines.map(function (l) {
        var item = { id: l.variant_id, quantity: l.quantity, selling_plan: planId };
        if (l.properties) item.properties = l.properties;
        return item;
      });
      return postJSON('/cart/add.js', { items: items }).then(function () {
        return removeOneTimeLines(lines.map(function (l) { return String(l.variant_id); }), groupTag);
      }).then(function (result) {
        clearJournal();
        return result;
      });
    });
  }

  /* Cart-level path: convert EVERY eligible one-time line in the cart, each to
     its own plan, in the same journaled add+remove pair the bundle path uses.

     Why a separate path rather than reusing convertBundle: that one takes a
     single planId for every line. Lunaire's plans are not one rate (the serums
     subscribe at 30%, the Hair/Skin/Nails gummies at 10%, different plan ids),
     so a shared plan would silently put some lines on the wrong plan or fail.
     /cart/add.js accepts a per-item selling_plan, so one POST still covers a
     mixed-plan cart and atomicity is preserved.

     data-sub-lines is "variantId:quantity:planId" joined by "|", written by
     snippets/lunaire-sub-offer from the live cart.

     The journal it writes is the SAME shape the existing resume logic reads
     ({variants, tag}); resumeOrHeal never consults journal.plan on the upgrade
     side, only on the revert side, so a mixed-plan conversion resumes
     correctly with no change to that code. */
  function convertMulti(btn) {
    var specs = (btn.getAttribute('data-sub-lines') || '')
      .split('|')
      .filter(Boolean)
      .map(function (chunk) {
        var bits = chunk.split(':');
        return { variantId: bits[0], quantity: parseInt(bits[1], 10) || 1, plan: parseInt(bits[2], 10) };
      })
      .filter(function (s) { return s.variantId && s.plan; });

    if (!specs.length) return Promise.resolve(null);

    return getCart().then(function (cart) {
      /* Resolve against the LIVE cart: the offer was rendered from a snapshot
         and she may have changed a quantity since. Untagged one-time lines
         only, matching what the offer is allowed to touch. */
      var lines = [];
      specs.forEach(function (spec) {
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (String(it.variant_id) !== spec.variantId) continue;
          if (it.selling_plan_allocation) continue;
          if (tagOf(it) !== '') continue; /* bundle lines convert from their card */
          if (lines.some(function (l) { return l.item === it; })) continue;
          lines.push({ item: it, plan: spec.plan });
          return;
        }
      });
      if (!lines.length) return null;

      var variantIds = lines.map(function (l) { return String(l.item.variant_id); });
      writeJournal({ variants: variantIds, plan: lines[0].plan, tag: '', ts: Date.now() });

      var items = lines.map(function (l) {
        /* Live quantity, not the rendered one. */
        var item = { id: l.item.variant_id, quantity: l.item.quantity, selling_plan: l.plan };
        if (l.item.properties) item.properties = l.item.properties;
        return item;
      });

      return postJSON('/cart/add.js', { items: items })
        .then(function () {
          return removeOneTimeLines(variantIds, '');
        })
        .then(function (result) {
          clearJournal();
          return result;
        });
    });
  }

  /* Single-line path: same journaled add+remove pair, for one line. */
  function convertSingle(btn, planId) {
    var capturedKey = btn.getAttribute('data-line-key');
    if (!capturedKey) return Promise.resolve(null);
    return getCart().then(function (cart) {
      var line = null;
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        if (it.key === capturedKey && !it.selling_plan_allocation) { line = it; break; }
      }
      if (!line) {
        var variantId = String(capturedKey).split(':')[0];
        for (var j = 0; j < cart.items.length; j++) {
          var cand = cart.items[j];
          if (String(cand.variant_id) === variantId && !cand.selling_plan_allocation) { line = cand; break; }
        }
      }
      if (!line) return null;
      var lineTag = tagOf(line);
      writeJournal({ variants: [String(line.variant_id)], plan: planId, tag: lineTag, ts: Date.now() });
      var item = { id: line.variant_id, quantity: line.quantity, selling_plan: planId };
      if (line.properties) item.properties = line.properties;
      return postJSON('/cart/add.js', { items: [item] })
        .then(function () {
          return removeOneTimeLines([String(line.variant_id)], lineTag);
        })
        .then(function (result) {
          clearJournal();
          return result;
        });
    });
  }

  /* Zero every one-time line of the given variants AND tag state in ONE
     /cart/update.js call, keyed by line key (never variant id: a variant-id
     key would also hit the freshly added subscription line). The tag filter
     keeps a standalone duplicate (different tag state) alive. Keys are
     re-read from the live cart because adding the subscription lines can
     detach the automatic Bundle & Save discount and re-hash the one-time
     lines' keys. */
  function removeOneTimeLines(variantIds, tag) {
    return getCart().then(function (cart) {
      var updates = {};
      var found = false;
      cart.items.forEach(function (it) {
        if (!it.selling_plan_allocation && variantIds.indexOf(String(it.variant_id)) !== -1 && tagOf(it) === (tag || '')) {
          updates[it.key] = 0;
          found = true;
        }
      });
      if (!found) return null;
      return postJSON('/cart/update.js', { updates: updates });
    });
  }

  /* -------- interrupted-pair resume + legacy healer (run once per load) --- */

  function resumeOrHeal() {
    var journal = readJournal();
    /* A pending revert wins: it is the shopper's most recent explicit choice,
       and letting the healer run first could re-subscribe the line they just
       stepped out of. */
    var revertJournal = readRevertJournal();
    if (revertJournal) { resumeRevert(revertJournal); return; }
    /* Skip the healer's cart fetch for the common case: no pending journal
       and no Shopify cart cookie (fresh visitor who never carted anything).
       NOTE: this theme's header has no .cart-count-bubble, so the cookie is
       the only cheap signal. */
    var hasCartCookie = document.cookie.split(';').some(function (c) { return c.trim().indexOf('cart=') === 0; });
    if (!journal && !hasCartCookie) return;
    if (journal) {
      if (Date.now() - (journal.ts || 0) > JOURNAL_MAX_AGE) { clearJournal(); return; }
      /* The add is atomic: either every journal variant has a plan line of
         the journal's tag state now (add landed, removal may be missing) or
         none do (nothing happened). */
      getCart().then(function (cart) {
        var journalTag = journal.tag || '';
        var subVariants = {};
        cart.items.forEach(function (it) {
          if (it.selling_plan_allocation && tagOf(it) === journalTag) subVariants[String(it.variant_id)] = true;
        });
        var added = journal.variants.every(function (v) { return subVariants[v]; });
        if (!added) { clearJournal(); return; } /* pre-add bail: nothing to finish */
        return removeOneTimeLines(journal.variants, journalTag).then(function (result) {
          clearJournal();
          if (result) return refreshCartUI();
        });
      }).catch(function () {});
      return;
    }

    /* Legacy healer: a bundle left part-subscribed by the old sequential code
       (or any other glitch). Only acts when the cart holds EVERY component of
       a bundle but split across modes — the state that ungroups the card and
       strands lines without the bundle discount. Deliberate partial carts
       (missing components, or a complete one-time set plus a lone extra sub
       line) are left alone. Finishes toward the subscription: a mixed state
       can only arise from a subscription conversion that did not complete. */
    getCart().then(function (cart) {
      var job = null;
      for (var b = 0; b < BUNDLES.length && !job; b++) {
        var def = BUNDLES[b];
        /* Heal within ONE tag-state group at a time: tagged lines (the PDP
           marker) and legacy untagged lines are separate populations, and a
           standalone untagged duplicate must never be counted as part of a
           tagged bundle (or vice versa). */
        var tagGroups = [def.handle, ''];
        for (var g = 0; g < tagGroups.length && !job; g++) {
          var groupTag = tagGroups[g];
          var subs = {}, ones = {};
          cart.items.forEach(function (it) {
            var vid = String(it.variant_id);
            if (def.variants.indexOf(vid) === -1) return;
            if (tagOf(it) !== groupTag) return;
            if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan &&
                String(it.selling_plan_allocation.selling_plan.id) === String(def.plan)) {
              subs[vid] = it;
            } else if (!it.selling_plan_allocation) {
              ones[vid] = it;
            }
          });
          var subCount = Object.keys(subs).length;
          var allPresent = def.variants.every(function (v) { return subs[v] || ones[v]; });
          if (subCount > 0 && subCount < def.variants.length && allPresent) {
            job = { def: def, tag: groupTag, stragglers: def.variants.filter(function (v) { return !subs[v]; }).map(function (v) { return ones[v]; }) };
          }
        }
      }
      if (!job) return;
      var items = job.stragglers.map(function (l) {
        var item = { id: l.variant_id, quantity: l.quantity, selling_plan: job.def.plan };
        if (l.properties) item.properties = l.properties;
        return item;
      });
      writeJournal({ variants: items.map(function (i) { return String(i.id); }), plan: job.def.plan, tag: job.tag, ts: Date.now() });
      return postJSON('/cart/add.js', { items: items })
        .then(function () {
          return removeOneTimeLines(items.map(function (i) { return String(i.id); }), job.tag);
        })
        .then(function () {
          clearJournal();
          return refreshCartUI();
        });
    }).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resumeOrHeal);
  } else {
    resumeOrHeal();
  }

  /* ----------------------------- plumbing -------------------------------- */

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          throw new Error((data && (data.message || data.description)) || 'Could not switch to a subscription.');
        }
        return data;
      });
    });
  }

  function writeJournal(value) {
    try { sessionStorage.setItem(JOURNAL_KEY, JSON.stringify(value)); } catch (e) {}
  }
  function readJournal() {
    try {
      var raw = sessionStorage.getItem(JOURNAL_KEY);
      var parsed = raw ? JSON.parse(raw) : null;
      if (!parsed || Object.prototype.toString.call(parsed.variants) !== '[object Array]' || !parsed.variants.length) return null;
      return parsed;
    } catch (e) { return null; }
  }
  function clearJournal() {
    try { sessionStorage.removeItem(JOURNAL_KEY); } catch (e) {}
  }

  function writeRevertJournal(value) {
    try { sessionStorage.setItem(REVERT_JOURNAL_KEY, JSON.stringify(value)); } catch (e) {}
  }
  function readRevertJournal() {
    try {
      var raw = sessionStorage.getItem(REVERT_JOURNAL_KEY);
      var parsed = raw ? JSON.parse(raw) : null;
      if (!parsed || !parsed.variant || !parsed.plan) return null;
      return parsed;
    } catch (e) { return null; }
  }
  function clearRevertJournal() {
    try { sessionStorage.removeItem(REVERT_JOURNAL_KEY); } catch (e) {}
  }

  /* Finish a revert interrupted between its add and its update. The add is
     atomic, so either a one-time line of this variant exists now (add landed,
     removal may be missing) or none does (nothing happened). */
  function resumeRevert(journal) {
    if (Date.now() - (journal.ts || 0) > JOURNAL_MAX_AGE) { clearRevertJournal(); return; }
    getCart().then(function (cart) {
      var journalTag = journal.tag || '';
      var added = cart.items.some(function (it) {
        return !it.selling_plan_allocation && String(it.variant_id) === journal.variant && tagOf(it) === journalTag;
      });
      if (!added) { clearRevertJournal(); return; } /* pre-add bail */
      return removeSubLines(journal.variant, journal.plan, journalTag).then(function (result) {
        clearRevertJournal();
        if (result) return refreshCartUI();
      });
    }).catch(function () {});
  }

  /* Re-render every cart surface present on the page. */
  function refreshCartUI() {
    var jobs = [];

    /* Cart drawer: reuse the sections + renderContents pattern.
       renderContents() calls open(), so an already-open drawer stays open. */
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      jobs.push(
        fetch('/?sections=cart-drawer,cart-icon-bubble')
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            drawer.renderContents({ sections: sections });
          })
      );
    }

    /* Cart page: section-render main-cart-items + main-cart-footer. */
    var mainItems = document.getElementById('main-cart-items');
    if (mainItems) {
      var sectionIds = [];
      var itemsId = mainItems.getAttribute('data-id');
      if (itemsId) sectionIds.push(itemsId);
      var mainFooter = document.getElementById('main-cart-footer');
      var footerId = mainFooter ? mainFooter.getAttribute('data-id') : null;
      if (footerId && footerId !== itemsId) sectionIds.push(footerId);

      if (!sectionIds.length) {
        window.location.reload();
        return Promise.resolve();
      }

      jobs.push(
        fetch(window.location.pathname + '?sections=' + sectionIds.join(','))
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            replaceInnerHTML(mainItems, sections[itemsId], '.js-contents');
            if (mainFooter && footerId) {
              replaceInnerHTML(mainFooter, sections[footerId], '.js-contents');
            }
          })
          .catch(function () {
            window.location.reload();
          })
      );
    }

    return Promise.all(jobs);
  }

  function replaceInnerHTML(rootElement, sectionHTML, selector) {
    if (!rootElement || !sectionHTML) return;
    var target = rootElement.querySelector(selector);
    var parsed = new DOMParser().parseFromString(sectionHTML, 'text/html').querySelector(selector);
    if (target && parsed) target.innerHTML = parsed.innerHTML;
  }
})();
